<script>
import GalleryPhoto from "@/components/GalleryPhoto.vue";
import { db } from "../firebase.js";
import { storage } from "../firebase.js";
import shortid from "short-id";

export default {
  data() {
    return {
      items: [],
      database: [],
      url: "",
      snackbar: false,
      caption: "",
    };
  },
  components: {
    GalleryPhoto,
  },
  created() {
    this.getImages();
  },
  methods: {
    addImage(url1, id1, caption1) {
      this.items.push({ imgURL: url1, id: id1, caption: caption1 });
    },
    getImages() {
      db.collection("gallery")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.addImage(doc.data().url, doc.id, doc.data().caption);
          });
        });
    },
    deleteItem(id) {
      console.log(id);
      db.collection("gallery")
        .doc(id)
        .delete()
        .then(() => {
          console.log("Document successfully deleted!");
          const pos = this.items.map((e) => e.id).indexOf(id);
          this.items.splice(pos, 1);
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
      var deleteRef = storage.ref().child("gallery").child(id);
      deleteRef.delete();
    },
    upload() {
      var uid = shortid.generate();
      var vm = this;
      var uploadRef = storage.ref().child("gallery").child(uid);
      uploadRef.put(this.$refs.file.files[0]).then((snapshot) => {
        snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection("gallery")
            .doc(uid)
            .set({ url: downloadURL, caption: vm.caption });
          vm.addImage(downloadURL, uid, vm.caption);
        });
      });
    },
  },
};
</script>

<template>
  <div class="container-gallery">
    <div v-for="item in items" :key="item.id" :span="8">
      <div class="left mb-4">
        <GalleryPhoto :imgURL="item.imgURL" :caption="item.caption" />
        <v-btn
          style="
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            background-color: red;
            color: white;
            font-size: medium;
          "
          @click="deleteItem(item.id)"
        >
          Delete
        </v-btn>
      </div>
    </div>
    <v-card class="pa-5" style="cursor: pointer">
      <input type="file" id="input" ref="file" />
      <v-btn
        @click="
          upload();
          snackbar = true;
        "
        >Upload</v-btn
      >
      <v-textarea rows="1" cols="20" v-model="caption" label="Caption"></v-textarea>
    </v-card>
    <v-card>
      <v-snackbar v-model="snackbar" multi-line>
        Loading

        <template v-slot:actions>
          <v-btn color="red" variant="text" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </div>
</template>

<style scoped>
.container-gallery {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: center;
}

.left {
  width: 100%;
  align-items: center;
}
</style>
